module.exports = __webpack_public_path__ + "static/img/zb1-4.dad0c5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/zb1-4.png
// module id = 734
// module chunks = 0